import { GetWishListApiParameter, getWishList } from "@NA/Services/ADIWishListService";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

interface Parameter {
    updateTab: string;
}

type HandlerType = CustomHandler<Parameter>;

export const UpdatePDPPageTab: HandlerType = (props) => {
    props.dispatch({
        type: "Data/PDP/UpdatePDPTabs",
        result: props.parameter.updateTab,
    });
};

export const chain = [UpdatePDPPageTab];

const updatePDPTab = createHandlerChainRunner(chain, "UpdatePDPPageTab");
export default updatePDPTab;
